import { render, staticRenderFns } from "./QuoteApproval.vue?vue&type=template&id=4ccea0db"
import script from "./QuoteApproval.vue?vue&type=script&lang=js"
export * from "./QuoteApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports